import { Alert, Snackbar } from "@mui/material";
import { SnackbarDisplayProps } from "./interface";

const SnackbarDisplay = ({
    alertState,
    alertData,
    setAlertState,
}: SnackbarDisplayProps) => {
    return (
        <Snackbar
            open={alertState === "" ? false : true}
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
            }}
            autoHideDuration={6000}
            onClose={() => {
                setAlertState("");
            }}
        >
            <Alert
                severity={alertState || "success"}
                onClose={() => {
                    setAlertState("");
                }}
            >
                {alertData}
            </Alert>
        </Snackbar>
    );
};

export default SnackbarDisplay;
